import React, { useCallback } from 'react';

import WizardButton from 'components/dialog/wizard/WizardButton.component';
import WizardModal from 'components/dialog/WizardModal.component';
import Button from 'components/form/Button.component';
import useCounter from 'hooks/useCounter.hook';
import useStateWhileMounted from 'hooks/useStateWhileMounted.hook';
import logger from 'utils/logger.util';

const L = logger('WizardPage');

const STATE = Object.freeze({
  init: 'first page',
  mid: 'middle page',
  end: 'final page',
  closed: 'closed wizard',
});

const WizardPage = () => {
  const [state, setState] = useStateWhileMounted(STATE.closed);
  const isOpen = state !== STATE.closed;

  const { val: attempt, inc: countAttempt } = useCounter();
  const { val: transition, inc: countTransition } = useCounter();

  const handleOpen = useCallback(() => {
    setState(STATE.init);
    countAttempt();
  }, [countAttempt, setState]);

  const handleChange = useCallback(
    ({ value }) => {
      L.debug('handleChange()', { attempt, transition, isOpen, state, value });
      setState(value);
      countTransition();
    },
    [attempt, transition, isOpen, state, setState, countTransition],
  );

  L.debug('()', { isOpen, attempt, state });

  const renderedInfo = (
    <p>
      The state is: {String(state)}
      <br />
      The attempt count is: {String(attempt)}
      <br />
      The number of transitions is: {String(transition)}
    </p>
  );

  return (
    <div data-bem="WizardPage">
      <Button onClick={handleOpen}>Open</Button>
      <WizardModal state={state} onChange={handleChange} isOpen={isOpen}>
        <WizardModal.State value={STATE.closed} />

        <WizardModal.State value={STATE.init}>
          <WizardModal.Title>Salon Modal Experiment: Start</WizardModal.Title>
          <WizardModal.Body>
            Hello, welcome to my modal wizard.
            {renderedInfo}
          </WizardModal.Body>
          <WizardModal.Footer>
            <WizardButton value={STATE.mid}>Next</WizardButton>
          </WizardModal.Footer>
        </WizardModal.State>

        <WizardModal.State value={STATE.mid}>
          <WizardModal.Title>Salon Modal Experiment: Middle</WizardModal.Title>
          <WizardModal.Body>
            <p>This is the middle page</p>
            {renderedInfo}
          </WizardModal.Body>
          <WizardModal.Footer>
            <WizardButton value={STATE.end}>Next</WizardButton>
          </WizardModal.Footer>
        </WizardModal.State>

        <WizardModal.State value={STATE.end}>
          <WizardModal.Title>Salon Modal Experiment: Finish</WizardModal.Title>
          <WizardModal.Body>
            ...aaaaaaand, this is the end.
            {renderedInfo}
          </WizardModal.Body>
          <WizardModal.Footer>
            <WizardButton value={STATE.mid}>Back</WizardButton>
            <WizardButton value={STATE.closed}>Finish</WizardButton>
          </WizardModal.Footer>
        </WizardModal.State>
      </WizardModal>
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default WizardPage;
